var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.032 19C15.0696 19 18.372 13.6132 18.372 8.94228C18.372 8.78894 18.372 8.63645 18.3624 8.48484C19.0048 7.98518 19.5592 7.36492 20 6.65506C19.4016 6.94107 18.7656 7.12887 18.1152 7.21158C18.8 6.76964 19.3128 6.07529 19.5584 5.25603C18.9136 5.66781 18.2088 5.95813 17.4736 6.11406C16.2304 4.6909 14.1512 4.62198 12.8288 5.96071C11.9768 6.82391 11.6144 8.11096 11.8792 9.33856C9.24 9.19555 6.7808 7.85337 5.1136 5.64541C4.2424 7.26068 4.688 9.3265 6.1304 10.3637C5.608 10.3473 5.0968 10.1957 4.64 9.92178V9.96657C4.6408 11.649 5.7424 13.098 7.2736 13.4314C6.7904 13.5736 6.2832 13.5942 5.792 13.4917C6.2216 14.9321 7.4544 15.9185 8.8584 15.9469C7.696 16.9307 6.26 17.4649 4.7816 17.4631C4.5208 17.4623 4.26 17.4459 4 17.4123C5.5016 18.4495 7.248 19 9.032 18.9974",
    fill: "#0FEFFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.9c03d03f21fd8a5037c700f9590b22ac.svg";
export { ForwardRef as ReactComponent };